// Figma: no frame provided yet — built using the established design system per the
// "extrapolate" decision.
// LOGIC PORTED from LC2's CampaignTab.js (commons/components/HomeTabs/Today/Campaign/):
// same useLazyGetCampaignByIdQuery fetch keyed off params.campaign_sfid. Composes
// CampaignInfo + the existing ResidentActionFeedTable (already filters by campaign_sfid)
// + the ported read-only Offers/OffersMainComponent (Offer Timeline + Offer Planner), gated
// by the same `isNotStake1` check as LC2 + AlertsSection (same). LC2's offer-editor modal
// system (New/Edit/Delete Offer) isn't ported — see Offers/OffersPlanner.js's header comment.
import React, {useEffect, useMemo} from 'react';
import {useParams} from 'react-router-dom';
import {Stack, Typography} from '@mui/material';

import {useLazyGetCampaignByIdQuery} from '../../features/actionsApi/campaignsSlice';
import CampaignInfo from './CampaignInfo';
import ResidentActionFeedTable from './ResidentActionFeedTable';
import AlertsSection from './AlertsSection';
import OffersMainComponent from './Offers/OffersMainComponent';

const CampaignDetailPage = () => {
    const params = useParams();
    const [fetchCampaign, {data: campaign, isSuccess, isLoading, isFetching, isError}] = useLazyGetCampaignByIdQuery();

    useEffect(() => {
        if (params?.campaign_sfid) {
            fetchCampaign(params.campaign_sfid);
        }
    }, [params?.campaign_sfid, fetchCampaign]);

    const isNotStake1 = useMemo(
        () => Boolean(campaign?.subtype && !campaign.subtype.toLowerCase().includes('stake1')),
        [campaign]
    );

    if (isLoading || isFetching) {
        return (
            <Typography variant="body2" color="text.secondary">
                Loading campaign…
            </Typography>
        );
    }

    if (isError) {
        return (
            <Typography variant="body2" color="error.main">
                Failed to load this campaign.
            </Typography>
        );
    }

    if (!isSuccess) return null;

    return (
        <Stack spacing={3}>
            <Typography variant="h5" fontWeight={600}>
                {campaign.name || campaign.subtype}
            </Typography>
            <CampaignInfo campaign={campaign} />
            <ResidentActionFeedTable />
            {isNotStake1 && <OffersMainComponent campaign={campaign} />}
            <AlertsSection />
        </Stack>
    );
};

export default CampaignDetailPage;
